import { axiosInstance } from 'boot/axios.js'

export async function get(ctx, queryParams = {}) {
  try {
    let id = queryParams.id
    delete queryParams.id
    const response = await axiosInstance({
      url: parseUrl('motorcycles/tyres/' + id, queryParams),
      params: queryParams,
      method: 'GET'
    })

    const modules = await axiosInstance({
      url: parseUrl('app-modules', {
        filters: 'where[category]=BFGOODRICH'
      }),
      params: {
        sort: 'order desc',
        'filters[where][type][eq]': 'TYRE_DETAIL',
        'filters[where][status][eq]': 'PUBLISHED',
        'filters[where][name][eq]': response.data.name,
        'filters[where][category][eq]': response.data.brand.toUpperCase(),
        limit: 1000
      },
      method: 'GET'
    })
    const warranty = await axiosInstance({
      url: parseUrl('app-modules', {}),
      params: {
        sort: 'order desc',
        'filters[where][type][eq]': 'WARRANTY',
        'filters[where][status][eq]': 'PUBLISHED',
        'filters[where][category][eq]': response.data.brand.toUpperCase(),
        limit: 1000
      },
      method: 'GET'
    })
    response.data.modules = modules.data.items
    response.data.warranty = warranty.data.items
    ctx.commit('item', response.data)

    return response
  } catch (e) {
    throw e
  }
}

export async function queryByMeasurements(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/tyres',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
  } catch (e) {
    throw e
  }
}

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/tyres',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('car', response.data.vehicle)
    ctx.commit('pagination', response.data.pagination)
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id
  }
  return '/' + state
}
